// @flow strict
import * as React from 'react';
import cx from 'classnames';

import DigitalQuote from '../DigitalQuote';
// eslint-disable-next-line css-modules/no-unused-class
import styles from './styles.scss';
import silverLogo from '../../static/images/ansarada-advantage-silver-white.png';
import bronzeLogo from '../../static/images/ansarada-advantage-bronze-white.png';
import partnerLogo from '../../static/images/ansarada-advantage-partner-white.png';
import platinumLogo from '../../static/images/ansarada-advantage-platinum-white.svg';
import goldLogo from '../../static/images/ansarada-advantage-gold-white.svg';
import ansaradaLogo from '../../static/images/ansarada-all-white-logo.png';
import ansaradaSymbol from '../../static/images/ansarada-logo-symbol-white.svg';
import PageContentBlock from '../../internal/PageContentBlock';

type Props = {|
  partnerName: string,
  logo: string,
  theme: 'gold' | 'platinum' | 'silver' | 'bronze' | 'partner',
  apiURL?: string,
  defaultCurrency: 'AUD' | 'USD' | 'EUR' | 'GBP' | 'ZAR',
  geolocationCode: string,
|};

const savingsPartnership = {
  platinum: 30,
  gold: 15,
  silver: 10,
  bronze: 5,
  partner: 0,
};

const DigitalQuotePartnership = ({
  defaultCurrency,
  partnerName,
  logo,
  theme,
  apiURL,
  geolocationCode,
}: Props) => {
  const savings = savingsPartnership[theme];
  return (
    <PageContentBlock removePadding removeMargin layout="Full">
      <div>
        <div
          className={cx([
            theme === 'platinum' && styles.headerPlatinum,
            theme === 'gold' && styles.headerGold,
            theme === 'silver' && styles.headerSilver,
            theme === 'bronze' && styles.headerBronze,
            theme === 'partner' && styles.headerPartner,
          ])}
        >
          <div className={styles.header}>
            {theme === 'platinum' && (
              <img src={platinumLogo} alt="Ansarada Advantage Partner Platinum" height="120" />
            )}
            {theme === 'gold' && (
              <img src={goldLogo} alt="Ansarada Advantage Partner Gold" height="120" />
            )}
            {theme === 'silver' && (
              <img src={silverLogo} alt="Ansarada Advantage Partner Silver" height="80" />
            )}
            {theme === 'bronze' && (
              <img src={bronzeLogo} alt="Ansarada Advantage Partner Bronze" height="80" />
            )}
            {theme === 'partner' && (
              <img src={partnerLogo} alt="Ansarada Advantage Partner" height="80" />
            )}
            <h1 className={styles.partnerName}>{partnerName} Loyalty Quote</h1>
            <a href="//ansarada.com">
              <img className={styles.ansaradaLogo} src={ansaradaLogo} alt="Ansarada" height="80" />
              <img
                className={styles.ansaradaSymbol}
                src={ansaradaSymbol}
                alt="Ansarada"
                height="40"
              />
            </a>
          </div>
        </div>
        <div className={styles.background}>
          <DigitalQuote
            defaultCurrency={defaultCurrency}
            apiURL={apiURL}
            color={theme}
            savings={savings}
            partnerName={partnerName}
            geolocationCode={geolocationCode}
          />
        </div>
        <div className={styles.section}>
          <h2
            className={cx([
              styles.h2,
              theme === 'gold' && styles.gold,
              theme === 'platinum' && styles.platinum,
              theme === 'silver' && styles.silver,
              theme === 'bronze' && styles.bronze,
              theme === 'partner' && styles.partner,
            ])}
          >
            Our customers
          </h2>
          {logo && (
            <div className={styles.logos}>
              <img src={`${logo}?width=800`} alt="" />
            </div>
          )}
        </div>
      </div>
    </PageContentBlock>
  );
};

export default DigitalQuotePartnership;
